export default __webpack_public_path__ + "d40d71174b53c25dd199c35bb40327ee.png";